<!-- =========================================================================================
    Breadcrumb do layout principal (router meta).
    - Itens explícitos: meta.breadcrumb — { title, url? } ou legado { text, to? }; opcional { active }.
    - Sem meta.breadcrumb (ou vazio): usa só meta.pageTitle como último nível (Home já cobre a raiz).
    - meta.hideBreadcrumb: não monta trilha (crumbs vazios).
========================================================================================== -->

<template>
  <div class="vx-breadcrumb" v-bind="$attrs">
    <ul
      v-if="hasBreadcrumb"
      class="flex flex-wrap items-center"
    >
      <li class="inline-flex items-end">
        <router-link to="/">
          <feather-icon
            icon="HomeIcon"
            class="h-5 w-5 mb-1 stroke-current text-primary"
          />
        </router-link>
        <span class="breadcrumb-separator mx-2">
          <feather-icon
            :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'"
            class="w-4 h-4"
          />
        </span>
      </li>
      <li
        v-for="(link, index) in middleCrumbs"
        :key="'crumb-mid-' + index"
        class="inline-flex items-center"
      >
        <router-link
          v-if="link.url"
          :to="link.url"
          class="breadcrumb-link text-neutral"
        >{{ label(link.title) }}</router-link>
        <span
          v-else
          class="text-neutral cursor-default"
        >{{ label(link.title) }}</span>
        <span class="breadcrumb-separator mx-2 flex items-start">
          <feather-icon
            :icon="isRTL ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'"
            class="w-4 h-4"
          />
        </span>
      </li>
      <li
        v-if="lastCrumb && lastCrumb.active !== false"
        class="inline-flex"
      >
        <span class="cursor-default text-neutral">{{ label(lastCrumb.title) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'vx-breadcrumb',
  inheritAttrs: false,
  props: {
    route: {
      type: Object,
      required: true
    },
    isRTL: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    crumbs() {
      const meta = (this.route && this.route.meta) || {}
      if (meta.hideBreadcrumb) {
        return []
      }
      const b = meta.breadcrumb
      const hasExplicit = Array.isArray(b) && b.length > 0
      const raw = hasExplicit
        ? b
        : meta.pageTitle
          ? [{ title: meta.pageTitle, active: true }]
          : []
      return raw.map((item) => {
        if (!item || typeof item !== 'object') {
          return { title: '', url: null, active: undefined }
        }
        const title =
          item.title != null && item.title !== ''
            ? item.title
            : item.text != null
              ? item.text
              : ''
        let url = null
        if (item.url != null && item.url !== '') {
          url = item.url
        } else if (
          item.to !== undefined &&
          item.to !== null &&
          item.to !== ''
        ) {
          url = item.to
        }
        // Hash mode: router-link com to="#" quebra o conteúdo do slot; tratar como texto sem link
        if (url === '' || url === '#' || url === '/#') {
          url = null
        }
        return {
          title,
          url,
          active: item.active
        }
      }).filter((c) => !this.isRedundantMuralCrumb(c))
    },
    hasBreadcrumb() {
      return this.crumbs.length > 0
    },
    middleCrumbs() {
      const list = this.crumbs
      if (list.length <= 1) {
        return []
      }
      return list.slice(0, -1)
    },
    lastCrumb() {
      const list = this.crumbs
      if (!list.length) {
        return null
      }
      return list[list.length - 1]
    }
  },
  methods: {
    isRedundantMuralCrumb(c) {
      const t = String(c.title || '').trim().toLowerCase()
      if (t !== 'mural') {
        return false
      }
      const u = c.url
      if (typeof u === 'object' && u !== null) {
        return false
      }
      if (u === '/' || u === '/#') {
        return true
      }
      if (u === undefined || u === null || u === '') {
        return true
      }
      return false
    },
    label(title) {
      if (title == null || title === '') {
        return ''
      }
      const raw = String(title).trim()
      if (!raw) {
        return ''
      }
      if (typeof this.$t !== 'function') {
        return raw
      }
      try {
        const translated = this.$t(raw)
        if (typeof translated === 'string' && translated.length > 0) {
          return translated
        }
        return raw
      } catch (e) {
        return raw
      }
    }
  }
}
</script>
